import React from 'react';
import ReactDOM from 'react-dom/client'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/style.css';

import Routes from './utils/Routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(< Routes />);
